import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()
export class FrequencyService {
  
  constructor(
    private http: HttpClient
  ) { }
  
  getFrequencyDropdown(): Observable<any> {
    return this.http.get(`${environment.dotNetApiUrl}/Transportation/Frequency/Dropdown`);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/notifications/frequency.service.ts